import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";

import "./Notification.scss";
import SentNotifications from "./SentNotifications";
import ScheduledNotification from "./ScheduledNotification";
import useButtonLoader from "hooks/useButtonLoader";
import { toast } from "sonner";
import { getNotificationListApi } from "services/notification";
import Pagination from "react-js-pagination";
import useFullPageLoader from "common/UseFullPageLoader";

const NotificationList = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [loader, onShow, onHide] = useFullPageLoader();
  const activePage = +searchParams.get("page") || 1;
  const [tab, setTab] = useState("sent");
  const [notificationList, setNotificationList] = useState([]);
  const [isScheduleNotification, setIsScheduleNotification] = useState(false);
  const [total, setTotal] = useState(0)
  // console.log('notificationList', isScheduleNotification, total)
  //-----------Handel-Pagination-----------
  const handlePageChange = (event) => {
    searchParams.set("page", event);
    setSearchParams(searchParams);
  };
  //-----------Handel-tabs-----------
  const handleChangeTab = (value) => {
    setTab(value);
    if (value === 'sent') {
      setIsScheduleNotification(false);
    } else {
      setIsScheduleNotification(true);
    }
    searchParams.set("page", 1);
    setSearchParams(searchParams);
  }
  //  ----------------notification-list----------------------
  const getNotificationList = async () => {
    try {
      onShow()
      const query = {
        // search: '',
        page: activePage,
        isScheduled: isScheduleNotification
      }
      const { data } = await getNotificationListApi(query);
      if (data?.code === 200) {
        setNotificationList(data?.data?.data || []);
        setTotal(data?.data?.total || 0)
      } else {
        toast.error(data?.message);
      }
    } catch (err) {
      console.error(err);
    } finally {
      onHide()
    }
  };

  useEffect(() => {
    getNotificationList();

    // eslint-disable-next-line
  }, [activePage, tab, isScheduleNotification]);

  useEffect(() => {
    if (activePage === 1) {
      searchParams.delete('page')
    }
    setSearchParams(searchParams)
  }, [activePage])
  return (
    <>
      <div className="notification_list">
        <div className="page_title has_child">
          <h3>Notification Management</h3>
          <Link to="/notification/create" className="button">
            Add Notification
          </Link>
        </div>

        <div className="card">
          {loader}
          <div className="card-body">
            <div className="has_child">
              <h5></h5>
              <div className="tab_button_wrap">
                <ul>
                  <li>
                    <button
                      type="button"
                      className={tab === "sent" ? "active" : ""}
                      onClick={() => handleChangeTab("sent")}
                    >
                      Sent Notifications
                    </button>
                    <button
                      type="button"
                      className={tab === "scheduled" ? "active" : ""}
                      onClick={() => handleChangeTab("scheduled")}
                    >
                      Scheduled Notifications
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            {tab === "sent" && (
              <SentNotifications
                notificationList={notificationList}
                setNotificationList={setNotificationList}
              />
            )}

            {tab === "scheduled" && (
              <ScheduledNotification
                notificationList={notificationList}
                setNotificationList={setNotificationList}
              />
            )}
          </div>
        </div>
        {total > 10 && (
          <div className="pagination-wrapper">
            <div className="Pagination">
              <Pagination
                activePage={activePage}
                previousLabel={"previous"}
                nextLabel={"next"}
                itemsCountPerPage={10}
                totalItemsCount={total}
                pageRangeDisplayed={5}
                onChange={handlePageChange}
                hideDisabled={true}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default NotificationList;
